import { Link, Outlet, useLocation } from "react-router-dom";

import { useState, useEffect, useMemo, useRef } from "react";

import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import life from '../../images/Life-logo.jpg';
import Sanket from '../../images/sanket.svg'


const useTypewriter = (text, speed = 20) => {
    const [index, setIndex] = useState(0);
    const displayText = useMemo(() => text.slice(0, index), [index]);
    useEffect(() => {
        if (index >= text.length)
            return;

        const timeoutId = setTimeout(() => {
            setIndex(i => i + 1);
        }, speed);

        return () => {
            clearTimeout(timeoutId);
        };
    }, [index, text, speed]);

    return displayText;
};

const Layout = ({ logos }) => {
    const location = useLocation();

    // State to control Program dropdown visibility
    const [programOpen, setProgramOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setProgramOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Close dropdown on route change
    useEffect(() => {
        setProgramOpen(false);
    }, [location.pathname]);

    // Extract year from the path (e.g., "/2026" -> "2026")
    const getYearFromPath = () => {
        const pathSegments = location.pathname.split('/');
        const yearSegment = pathSegments.find(segment => /^\d{4}$/.test(segment));
        return yearSegment || '2026';
    };

    const currentYear = getYearFromPath();

    return (
        <>
            {/* Header */}
            <div className="logos">
                <div className="life">
                    <img src={Sanket} alt="Sanket" />
                </div>

                {logos.map((p, idx) => (
                    <div key={idx} className={p.className}>
                        <a href={p.href} target="_blank" rel="noopener noreferrer">
                            <img src={p.img} alt={p.alt} title={p.alt} />
                        </a>
                    </div>
                ))}
            </div>

            {/* Title */}
            <h1 className="text-center text-2xl lg:text-4xl m-4" style={{ color: '#010d82' }}>
                SANKET  - {useTypewriter("Sustainability through Ancient Knowledge and Emerging Technologies", 50)}
            </h1>

            <Navbar expand="lg" className="bg-body-tertiary mb-2">
                <Container>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                            <Link to={`/${currentYear}`} className="nav-link" onClick={
                                () => {
                                    if (window.outerWidth < 768) {
                                        document.querySelector('.navbar-toggler').click();
                                    }
                                    document.querySelectorAll('.nav-link').forEach((link) => {
                                        link.classList.remove('activeTab');
                                    })
                                    document.querySelectorAll('.nav-link')[0].classList.add('activeTab');
                                }
                            }>Home</Link>

                            <Link to={`/${currentYear}/about`} className="nav-link" onClick={
                                () => {
                                    if (window.outerWidth < 768) {
                                        document.querySelector('.navbar-toggler').click();
                                    }
                                    document.querySelectorAll('.nav-link').forEach((link) => {
                                        link.classList.remove('activeTab');
                                    })
                                    document.querySelectorAll('.nav-link')[1].classList.add('activeTab');
                                }
                            }>About Us</Link>

                            <Link to={`/${currentYear}/supporters`} className="nav-link" onClick={
                                () => {
                                    if (window.outerWidth < 768) {
                                        document.querySelector('.navbar-toggler').click();
                                    }
                                    document.querySelectorAll('.nav-link').forEach((link) => {
                                        link.classList.remove('activeTab');
                                    })
                                    document.querySelectorAll('.nav-link')[2].classList.add('activeTab');
                                }
                            }>Supporters</Link>

                            <Link to={`/${currentYear}/venue`} className="nav-link" onClick={
                                () => {
                                    if (window.outerWidth < 768) {
                                        document.querySelector('.navbar-toggler').click();
                                    }
                                    document.querySelectorAll('.nav-link').forEach((link) => {
                                        link.classList.remove('activeTab');
                                    })
                                    document.querySelectorAll('.nav-link')[3].classList.add('activeTab');
                                }
                            }>Venue</Link>

                            <Link to={`/${currentYear}/registration`} className="nav-link" onClick={
                                () => {
                                    if (window.outerWidth < 768) {
                                        document.querySelector('.navbar-toggler').click();
                                    }
                                    document.querySelectorAll('.nav-link').forEach((link) => {
                                        link.classList.remove('activeTab');
                                    })
                                    document.querySelectorAll('.nav-link')[4].classList.add('activeTab');
                                }
                            }>Registration</Link>

                            <Link to={`/${currentYear}/author`} className="nav-link" onClick={
                                () => {
                                    if (window.outerWidth < 768) {
                                        document.querySelector('.navbar-toggler').click();
                                    }
                                    document.querySelectorAll('.nav-link').forEach((link) => {
                                        link.classList.remove('activeTab');
                                    })
                                    document.querySelectorAll('.nav-link')[5].classList.add('activeTab');
                                }
                            }>Authors</Link>

                            {/* ✅ FIXED: Program Dropdown using React state */}
                            <div
                                ref={dropdownRef}
                                className="nav-link"
                                style={{ position: 'relative', cursor: 'pointer', userSelect: 'none' }}
                            >
                                {/* Toggle on both hover and click for maximum compatibility */}
                                <div
                                    onClick={() => setProgramOpen(prev => !prev)}
                                    onMouseEnter={() => setProgramOpen(true)}
                                    style={{ display: 'flex', alignItems: 'center', gap: '4px' }}
                                >
                                    Program
                                    {/* Small arrow indicator */}
                                    <span style={{
                                        fontSize: '10px',
                                        transform: programOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                        transition: 'transform 0.2s',
                                        display: 'inline-block'
                                    }}>▾</span>
                                </div>

                                {/* Dropdown Menu */}
                                {programOpen && (
                                    <div
                                        onMouseLeave={() => setProgramOpen(false)}
                                        style={{
                                            position: 'absolute',
                                            left: 0,
                                            top: '100%',
                                            backgroundColor: '#fff',
                                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                            marginTop: '4px',
                                            zIndex: 9999,
                                            minWidth: '180px',
                                            border: '1px solid #e5e7eb',
                                            borderRadius: '4px',
                                            overflow: 'hidden'
                                        }}
                                    >
                                        <Link
                                            to={`/${currentYear}/program/keynote-speakers`}
                                            onClick={() => {
                                                setProgramOpen(false);
                                                if (window.outerWidth < 768) {
                                                    document.querySelector('.navbar-toggler').click();
                                                }
                                            }}
                                            style={{
                                                display: 'block',
                                                padding: '10px 16px',
                                                color: '#010d82',
                                                textDecoration: 'none',
                                                fontSize: '14px',
                                                whiteSpace: 'nowrap'
                                            }}
                                            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                                            onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                                        >
                                            Keynote Speakers
                                        </Link>

                                        {/* Add more program sub-items here in the same pattern */}
                                    </div>
                                )}
                            </div>

                            <Link to={`/${currentYear}/committee`} className="nav-link" onClick={
                                () => {
                                    if (window.outerWidth < 768) {
                                        document.querySelector('.navbar-toggler').click();
                                    }
                                    document.querySelectorAll('.nav-link').forEach((link) => {
                                        link.classList.remove('activeTab');
                                    })
                                    document.querySelectorAll('.nav-link')[6].classList.add('activeTab');
                                }
                            }>Committee</Link>

                            <Link to={`/${currentYear}/awards`} className="nav-link" onClick={
                                () => {
                                    if (window.outerWidth < 768) {
                                        document.querySelector('.navbar-toggler').click();
                                    }
                                    document.querySelectorAll('.nav-link').forEach((link) => {
                                        link.classList.remove('activeTab');
                                    })
                                    document.querySelectorAll('.nav-link')[7].classList.add('activeTab');
                                }
                            }>Awards</Link>

                            <Link to={`/${currentYear}/contact`} className="nav-link" onClick={
                                () => {
                                    if (window.outerWidth < 768) {
                                        document.querySelector('.navbar-toggler').click();
                                    }
                                    document.querySelectorAll('.nav-link').forEach((link) => {
                                        link.classList.remove('activeTab');
                                    })
                                    document.querySelectorAll('.nav-link')[8].classList.add('activeTab');
                                }
                            }>Contact</Link>

                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>

            <Outlet />

            <footer className="footer text-center text-lg absolute bottom-0 w-full py-3 bg-gradient-to-b from-white to-gray-400" style={{ color: '#010d82' }}>
                &copy; 2026 SANKET-Sustainability through Ancient Knowledge and Emerging Technologies. All Rights Reserved.
            </footer>
        </>
    )
};

export default Layout;
